import { MultimediaCartStatusType } from "chaild-entity/src/constant/multimediaCartStatus";

export const getStatusColor = (status: MultimediaCartStatusType) => {
  switch (status) {
    case 'inProgress':
      return 'primary';
    case 'paymentRequired':
      return 'socondary';
    case 'paymentExpired':
      return 'red';
    case 'paymentCancelled':
      return 'grey';
    case 'paid':
      return 'green';
    case 'printOrdered':
      return 'purple';
    case 'shipped':
      return 'blue';
  }
};

export const getStatusString = (status: MultimediaCartStatusType) => {
  switch (status) {
    case 'inProgress':
      return '購入前';
    case 'paymentRequired':
      return '未支払';
    case 'paymentExpired':
      return '期限切れ';
    case 'paymentCancelled':
      return 'キャンセル';
    case 'paid':
      return '支払済';
    case 'printOrdered':
      return 'プリント購入含む';
    case 'shipped':
      return '出荷済み';
  }
};
